export const isObjectEmpty = (v) => {
    return Object.keys(v).length === 0;
};
export const getObjectLength = (v) => {
    return Object.keys(v).length;
};
export const stripNullish = (obj) => {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
        if (!(value === null || value === undefined)) {
            //@ts-expect-error non-checkable by ts
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            result[key] = value;
        }
    }
    //@ts-expect-error non-checkable by ts
    return result;
};
export const patchObject = (obj, patch) => {
    for (const [key, value] of Object.entries(patch)) {
        if (!(value === null || value === undefined)) {
            //@ts-expect-error non-checkable by ts
            obj[key] = value;
        }
    }
    return obj;
};
//# sourceMappingURL=object.js.map